import { Link } from "react-router-dom";
import { MapPin, Phone, Mail } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, ADDRESS, EMAIL, EMAIL_MAILTO, scrollToId } from "@/lib/site";

const LINKS = [
  { label: "Home", id: null },
  { label: "About", id: "story" },
  { label: "A2 Gir Cow Ghee", id: "product" },
  { label: "Products", id: "more" },
  { label: "Why MAHIRA", id: "why-mahira" },
  { label: "Wholesale", id: "wholesale" },
  { label: "Distribution", id: "wholesale" },
  { label: "Contact", id: "contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="grain bg-forest text-ivory">
      <div className="mx-auto max-w-7xl px-5 py-20 md:px-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <p className="font-heading text-4xl font-semibold tracking-[0.12em]">
              MAHIRA
            </p>
            <p className="mt-1 text-[10px] font-semibold uppercase tracking-[0.42em] text-gold">
              Agro Products
            </p>
            <p className="mt-6 font-heading text-2xl italic text-ivory/85">
              Pure by Tradition. Made for the World.
            </p>
            <div className="mt-8 space-y-3 text-sm text-ivory/70">
              <a
                data-testid="footer-phone"
                href={PHONE_TEL}
                className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
              >
                <Phone className="h-4 w-4 text-gold" /> {PHONE_DISPLAY}
              </a>
              <a
                data-testid="footer-email"
                href={EMAIL_MAILTO}
                className="flex items-center gap-3 transition-colors duration-300 hover:text-gold"
              >
                <Mail className="h-4 w-4 text-gold" /> {EMAIL}
              </a>
              <p className="flex items-start gap-3" data-testid="footer-address">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-gold" />
                {ADDRESS}
              </p>
            </div>
          </div>

          <div className="lg:col-span-4">
            <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">
              Explore
            </p>
            <nav className="mt-6 grid grid-cols-2 gap-x-6 gap-y-3">
              {LINKS.map((l) => (
                <button
                  key={l.label}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={() =>
                    l.id
                      ? scrollToId(l.id)
                      : window.scrollTo({ top: 0, behavior: "smooth" })
                  }
                  className="link-underline w-fit text-left text-sm text-ivory/70 transition-colors duration-300 hover:text-ivory"
                >
                  {l.label}
                </button>
              ))}
            </nav>
          </div>

          <div className="lg:col-span-3">
            <p className="text-[11px] font-semibold uppercase tracking-[0.35em] text-gold">
              Legal
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <Link
                data-testid="footer-privacy-link"
                to="/privacy"
                className="link-underline w-fit text-sm text-ivory/70 transition-colors duration-300 hover:text-ivory"
              >
                Privacy Policy
              </Link>
              <Link
                data-testid="footer-terms-link"
                to="/terms"
                className="link-underline w-fit text-sm text-ivory/70 transition-colors duration-300 hover:text-ivory"
              >
                Terms &amp; Conditions
              </Link>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-ivory/15 pt-8 text-xs text-ivory/50 md:flex-row md:items-center">
          <p data-testid="footer-copyright">
            © 2026 MAHIRA Agro Products. All rights reserved.
          </p>
          <p className="tracking-[0.2em] uppercase">Born in India · Made for the World</p>
        </div>
      </div>
      <div className="h-16 md:hidden" aria-hidden />
    </footer>
  );
}
